<template>
  <dl :class="['addon-group', 'error-block', isError ? 'is-error' : '']">
    <dt>{{ spec.text }}</dt>
    <dd
      :class="[
        'addon-item',
        isSelected(color) ? 'is-active' : '',
        color.enabled ? '' : 'is-disabled'
      ]"
      v-for="(color, i) in spec.values"
      :key="i"
    >
      <label @click="onColorClick(color)">
        <i :class="['icon-checkbox', isSelected(color) ? 'icon-checkbox--checked' : '']"></i>
        <span
          class="addon-item__img"
          v-if="spec.isSpecImage && color.specImg"
          v-on:mouseover="showBigImg(color, $event)"
          v-on:mouseout="hideBigImg($event)"
          ><img :src="color.specImg" :alt="color.text" class="spec-option-image"
        /></span>
        <span class="addon-item__text">{{ color.text }}</span>
        <span
          class="addon-item__price"
          v-show="color.price > 0"
          v-if="
            (color.value === 'No' && color.text === 'No') === false && color.text === color.value
          "
          >{{ color.price > 0 ? `${formatCurrency(color.price)} each.` : 'Free' }}</span
        >
      </label>
    </dd>
    <dd class="error-label" v-show="isError">Please, select {{ spec.name }}.</dd>
  </dl>
</template>

<script lang="ts">
import { type SpecGroup, type SpecItem } from '../../types'
import { computed, defineComponent, inject, type PropType, ref } from 'vue'
import { SHOW_BIG_IMAGE_KEY } from '../../token'
import { formatCurrency } from '@anypromo/shared/utils/helper'

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<SpecItem>,
      default: () => undefined
    },
    spec: {
      type: Object as PropType<SpecGroup>,
      default: {} as unknown
    },
    isClicked: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'update:modelValue': (color?: SpecItem) => true,
    // 'color-click': (name: string, color: SpecItem) => true,
    'disabled-color': (name: string, color: SpecItem) => true
  },
  setup(props, { emit, expose }) {
    // useParent(addonContextKey)
    const showBigImage = inject(SHOW_BIG_IMAGE_KEY)
    if (!showBigImage) {
      console.warn('build error')
    }

    // 是否有错误
    const isError = computed(() => {
      return props.isClicked && (props.modelValue === null || props.modelValue === undefined)
    })

    const isSelected = (color: SpecItem) => props.modelValue?.value === color.value

    const onColorClick = (color: SpecItem) => {
      // 如果颜色不可选，那就出发提示
      if (color.enabled === false) {
        emit('disabled-color', props.spec.name, color)
        return
      }
      if (props.modelValue === color) {
        emit('update:modelValue', undefined)
      } else {
        emit('update:modelValue', color)
      }
    }

    const showBigImg = (color: SpecItem, evt: MouseEvent) => {
      if (showBigImage) {
        const specImage = color.specImg.replace('/specimage_0030/', '/specimage_medium/')
        const target = evt.target as HTMLElement
        showBigImage.show(specImage, '', target)
      }
    }
    const hideBigImg = (evt: MouseEvent) => {
      if (showBigImage) {
        showBigImage.hide()
      }
    }

    return {
      formatCurrency,
      isSelected,
      isError,
      onColorClick,
      showBigImg,
      hideBigImg
    }
  }
})
</script>
<style lang="less">
.addon-group {
  padding: 0;
  margin-bottom: 2px;
  dt {
    display: block;
    margin-bottom: 6px;
    font-size: 14px;
  }
}
.addon-item {
  label {
    font-weight: 500;
    padding: 5px 20px;
    font-size: 13px;
    cursor: pointer;
    max-width: 100%;
    margin-bottom: 5px;
    display: inline-flex;
    align-items: center;
    &:hover {
      background-color: #fff4de;
    }
  }
  span {
    vertical-align: middle;
  }
  &__img {
    margin-left: 7px;
    width: 30px;
    text-align: center;
    img {
      vertical-align: middle;
    }
  }
  &__text {
    flex: 1;
    margin-left: 15px;
    vertical-align: middle;
    text-align: left;
  }
  &__price {
    font-style: normal;
    display: inline-block;
    text-align: left;
    min-width: 60px;
    &::before {
      content: '-';
      padding: 0 5px;
    }
  }

  &.is-disabled {
    label {
      cursor: not-allowed;
    }
  }
  &.is-disabled {
    color: #ddd;
  }
  &.is-disabled &__img {
    opacity: 0.3;
  }
}
</style>
